module.exports = __webpack_public_path__ + "static/media/fig_29b.3db2d0fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_29b.jpg
// module id = 669
// module chunks = 0